<template>
  <div class="system-info-page">
    <Form :label-width="100">
      <div class="fielset">
        <h3>{{$t("system.SystemAuth.Information")}}</h3>
        <FormItem :label="$t('system.SystemAuth.systemVersion')">
            <Input class="info" v-model="systemVersion" disabled></Input>
        </FormItem>
        <FormItem :label="$t('system.SystemAuth.systemDealTime')">
            <Input class="info" v-model="systemDealTime" disabled></Input>
        </FormItem>
        <FormItem :label="$t('system.SystemAuth.systemAuthCode')">
            <Input class="info" v-model="systemAuthCode" :placeholder="$t('system.SystemAuth.please_enter')"></Input>
        </FormItem>
      </div>
      <hr>
      <div class="save-btn">
        <Button type="primary" v-if="permissions === true" @click="save()">{{$t("system.SystemAuth.save")}}</Button>
        <Button type="primary" v-if="permissions !== true" @click="save()" disabled>{{$t("system.SystemAuth.save")}}</Button>
      </div>
    </Form>
  </div>
</template>
<script>
import { Api } from '@/api'
export default {
  name: 'SystemInfo',
  data () {
    return {
      systemVersion: 'v0.11-beta',
      systemDealTime: '',
      systemAuthCode: '',
      permissions: false
    }
  },
  mounted () {
    Api.user.fetchUserInfo().then(res => {
      for (let i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'system' && res.user.permissions[i].value === 3) {
          this.permissions = true
        }
      }
    })
  },
  methods: {
    save () {
      Api.systemAuth.update(this.systemAuthCode).then(res => {
        let et = new Date(res.expiryTime * 1000)
        this.systemDealTime = et.getFullYear() + '-' + (et.getMonth() + 1) + '-' + et.getDate()
        this.$Message.config({
          top: 80,
          duration: 2
        })
        this.$Message.success(this.$t('system.SystemAuth.save_success'))
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    Api.systemAuth.get().then(res => {
      next(vm => {
        vm.systemAuthCode = res.systemAuthCode.authCode
        let et = new Date(res.systemAuthCode.expiryTime * 1000)
        vm.systemDealTime = et.getFullYear() + '-' + (et.getMonth() + 1) + '-' + et.getDate()
      })
    })
  }
}
</script>
<style scoped>
  .system-info-page {
    padding: 10px;
    padding-left: 20px;
  }
  .fielset .info {
    width: 33.3333%;
  }
  .save-btn {
    text-align: left;
  }
  hr {
    background-color: #dbdbdb;
    border: none;
    display: block;
    height: 1px;
    margin: 1.5rem 0;
  }
</style>


// WEBPACK FOOTER //
// SystemAuth.vue?4c3bdb42